module.exports = ".modal-dialog {\n  position: fixed;\n  width: 50vw !important;\n  height: 30vh !important;\n  left: 25vw;\n  top: 35vh;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/modal-confirm-input/modal-confirm-input.component.css
// module id = ./src/app/shared/modal/modal-confirm-input/modal-confirm-input.component.css
// module chunks = main